// extracted by mini-css-extract-plugin
module.exports = {"tab":"MyJobs_tab__1km84","tabContainer":"MyJobs_tabContainer__2grrF","crumbsContainer":"MyJobs_crumbsContainer__3Sn70","postJobBtn":"MyJobs_postJobBtn__GwUhN"};